import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app--showcase-ui-wrapper',
  template: `
    <ng-container *ngIf="uiVersion === 'new'; else oldUi">
      <app-new-movie-info></app-new-movie-info>
    </ng-container>
    <ng-template #oldUi>
      <app-movie-info></app-movie-info>
    </ng-template>
  `,
})
export class ShowcaseUiWrapperComponent {
  uiVersion: string;
  movieId:any;
  movieName:any;
  year:any;
  constructor(private route: ActivatedRoute) {
    this.year = +this.route.snapshot.paramMap.get('year')!;
        if( this.year >= 2025){
            this.uiVersion = 'new'; // Default to 'old'
        }else{
            this.uiVersion ='old';
        }
  }
}
